import { useMemo } from "react";
import { HotlineControl } from "components/LeafletMap/TrackpointControls/HotlineControl";
import { NonRoutingControl } from "components/LeafletMap/TrackpointControls/NonRoutingControl";
import { RoutingControl } from "components/LeafletMap/TrackpointControls/RoutingControl";
import { TrackHover } from "components/LeafletMap/TrackpointControls/TrackHover";
import { INTERACTION_SETTINGS } from "config/constants";
import { Routing } from "config/enums/routings";
import { useActionTimeout } from "hooks/useActionTimeout";
import { useEditMode } from "stores/useEditMode";
import { useHotkeys } from "react-hotkeys-hook";
import { useOptions } from "stores/optionsStore/OptionsContext";
import { useRouting } from "stores/routingStore/RoutingContext";

export const RoutingContainer = () => {
  const actionTimeout = useActionTimeout(
    INTERACTION_SETTINGS.markerActionTimeout
  );
  const { state, history } = useRouting();
  const { editMode } = useEditMode();
  const {
    state: { hotlineType },
  } = useOptions();

  // useKey: match the typed letter, not the key position (Z and Y are swapped on QWERTZ layouts)
  useHotkeys("ctrl+z", () => history.undo(), { useKey: true });
  useHotkeys("ctrl+y", () => history.redo(), { useKey: true });

  return useMemo(
    () =>
      editMode !== "measurement" ? (
        <>
          {hotlineType !== "none" && <HotlineControl />}
          {state.routing !== Routing.none ? (
            <RoutingControl actionTimeout={actionTimeout} />
          ) : (
            <NonRoutingControl actionTimeout={actionTimeout} />
          )}
          <TrackHover />
        </>
      ) : null,
    [actionTimeout, editMode, hotlineType, state.routing]
  );
};
